<template>
  <div class="content-cards">
    <v-card>
      <div class="card-mark">{{ counter }}</div>
      <div class="card-text">{{ note }}</div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'MirrorTextMarkup',
  props: {
    note: String,
    counter: String,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';
@import '@/assets/scss/theme-v2.scss';

.content-cards {
  width: 100%;
  background-color: $color-gray-lighter;
  @include for-size(desktop-up) {
    padding: 0;
  }
  .v-card {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
    padding: 16px;
    margin: 0 0 8px 0;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba($color-gray-darker, 0.2);

    .card-mark,
    .card-text {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
    }

    .card-mark {
      width: 32px;
      height: 32px;
      margin: 0;
      border-radius: 4px;
      background-color: $color-gray-main;
      font-size: 0.8em;
      font-family: 'globotipo' !important;
      font-weight: 600 !important;
      color: $color-gray-lighter;
    }

    .card-text {
      flex: 1;
      justify-content: flex-start;
      margin: 0 0 0 16px;
      border-radius: 0;
      word-break: break-all;
      line-height: 1.2em;
    }
  }
}
</style>
